import { Component, Input } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BaseLearningSectionComponent } from '../../../../shared/learning-section/base-learning-section/base-learning-section.component';
import { LearnerJourneyTarget } from '../../../../_models/timeline-models/learner-journey-target';
import { LearningSectionFlowControlHelperService } from '../../../../_helpers/learning-section-flow-control-helper/learning-section-flow-control-helper.service';
import { ProgressSection } from '../../../../_models/timeline-models/section-models/progress-section.model';
import { TimelineSectionStatus } from '../../../../_models/timeline-models/timeline-section-status.enum';
import { SuccessModalHelperService } from '../../../../_helpers/success-modal-helper/success-modal-helper.service';
import { TimelineSectionsService } from '../../../../_services/timeline-sections/timeline-sections.service';
import { ErrorModalHelperService } from '../../../../_helpers/error-modal-helper/error-modal-helper.service';
import { BandingsService } from '../../../../_services/shared/bandings.service';

@Component({
    selector: 'Progress-section',
    templateUrl: './progress-section.component.html',
    styleUrls: ['./progress-section.component.css'],
    standalone: false
})
export class ProgressSectionComponent extends BaseLearningSectionComponent {

  @Input() timelineSection: ProgressSection = new ProgressSection();
  public progressList: LearnerJourneyTarget[] = [];

  constructor(private readonly bandingService: BandingsService,
    protected readonly flowHelperService: LearningSectionFlowControlHelperService,
    public dialog: MatDialog,
    private successModalHelper: SuccessModalHelperService,
    private timelineSectionService: TimelineSectionsService,
    private errorModalHelper: ErrorModalHelperService
  ) {
    super(flowHelperService, dialog);
    this.sectionTitle = 'Progress';
    bandingService.getBandingsList().subscribe(data => {
      this.progressList = data;
    });
  }

  public learnerJourneyDescription(): string {
    if (this.timelineSection.currentProgress && this.progressList.length > 0) {
      return this.progressList.find(progress => {
        return progress.text === this.timelineSection.currentProgress;
      }).furtherInformation;
    }
    return '';
  }
    
  validate(): boolean {
    let sectionDate = new Date(this.timelineSection.sectionDate)
    sectionDate.setHours(0, 0, 0, 0);
    return sectionDate >= this.minSectionDate;
  }
 
  public save(dialogRef: MatDialogRef<any>): void {
    if (this.validate()) {
      let oldStatus = this.timelineSection.status;
      this.timelineSection.status = TimelineSectionStatus.Saved;
      this.postMerge(oldStatus);
    }
  }

  public delete(dialogRef: MatDialogRef<any>): void {
    this.timelineSectionService.deleteProgressSection(this.timelineSection).subscribe((response) => {
    });
}
  
  public unlock(dialogRef: MatDialogRef<any>): void {
      let oldStatus = this.timelineSection.status;
      this.timelineSection.status = TimelineSectionStatus.Unlock;
      this.postMerge(oldStatus);
  }
  
  public submit(dialogRef: MatDialogRef<any>): void {
    if (this.validate()) {
      let oldStatus = this.timelineSection.status;
      this.timelineSection.status = TimelineSectionStatus.Submitted;
      this.postMerge(oldStatus);
    }
  }
  
  public approve(dialogRef: MatDialogRef<any>): void {
    let oldStatus = this.timelineSection.status;
    this.timelineSection.status = TimelineSectionStatus.Approved;
    this.postMerge(oldStatus);
  }
  
  public reject(dialogRef: MatDialogRef<any>): void {
    let oldStatus = this.timelineSection.status;
    this.timelineSection.status = TimelineSectionStatus.Rejected;
    this.postMerge(oldStatus);
  }

  private postMerge(oldStatus: TimelineSectionStatus): void {
    this.timelineSectionService.mergeProgressSection(this.placementId, this.students.map(s => s.studentId), this.subject, this.timelineSection).subscribe((response: ProgressSection) => {
      this.timelineSection = response;
      this._sectionStatusUpdated.next(response.status);
      this.successModalHelper.show(this.timelineSection.status + " successfully");
    }, error => {
      console.error(error);
      this.errorModalHelper.show(error.message, error);
      this.timelineSection.status = oldStatus;
    });
  }

}
